/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { Toaster } from 'app/shared/lib/toaster';

@autoinject
export class FormTestsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(private readonly toaster: Toaster, ...rest: any[]) {
        super(...rest);
    }

    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }

    ////****************** Events ***************************************************////

    protected handleFormSuccess(event: Event): void {
        this.toaster.standard.notImplemented();
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
